import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

interface AvatarInitialsProps {
  firstName?: string;
  lastName?: string;
  size?: number; // diameter in px
  backgroundColor?: string;
  textColor?: string;
}

export const AvatarInitials: React.FC<AvatarInitialsProps> = ({
  firstName,
  lastName,
  size = 48,
  backgroundColor = ADMIN_COLORS.PRIMARY + '20',
  textColor = ADMIN_COLORS.PRIMARY,
}) => {
  const initials = React.useMemo(() => {
    const f = firstName?.charAt(0)?.toUpperCase() || '';
    const l = lastName?.charAt(0)?.toUpperCase() || '';
    return (f + l) || '??';
  }, [firstName, lastName]);

  return (
    <View style={[styles.avatar, { width: size, height: size, borderRadius: size / 2, backgroundColor }]}> 
      <Text style={[styles.text, { color: textColor, fontSize: Math.max(12, size * 0.375) }]}>
        {initials}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  avatar: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    fontWeight: '600',
  },
});


